interface QueryDisplayProps {
  query: string;
}

export default function QueryDisplay({ query }: QueryDisplayProps) {
  return (
    <div
      className="ghw-shrink-0"
      style={{
        background: "#13161a",
        padding: 16,
        borderRadius: "0 8px 8px 0",
        borderLeft: "2px solid #ff4fae",
        fontFamily: "'Inter', sans-serif",
        fontSize: 14,
        lineHeight: "20px",
        color: "#ffffff",
      }}
    >
      {query}
    </div>
  );
}
